import { NgIf, AsyncPipe } from '@angular/common'
import { Component } from '@angular/core'
import { BannerComponent, GenericLinkComponent } from '@spartacus/storefront'
import { EbResponsiveMediaComponent } from '../responsive-media/eb-responsive-media.component'
import { EbCmsBannerComponent } from './eb-banner.interface'

@Component({
  selector: 'eb-banner',
  templateUrl: './eb-banner.component.html',
  styleUrls: ['./eb-banner.component.scss'],
  imports: [NgIf, GenericLinkComponent, EbResponsiveMediaComponent, AsyncPipe]
})
export class EbBannerComponent extends BannerComponent {
  getTarget(data: EbCmsBannerComponent): string | null {
    return (data.external === undefined && data.externalLink === undefined) ||
      data.external === 'true' ||
      data.external === true ||
      data.externalLink === 'true' ||
      data.externalLink === true
      ? '_blank'
      : null
  }

  hasUrl(data: EbCmsBannerComponent): boolean {
    return data.urlLink && typeof data.urlLink === 'string' && data.urlLink !== ''
  }
}
